import React from "react";
import { localize } from "redux-i18n";
import { compose } from "redux";
import { View, SchemaForm } from "@components";

type Props = {
  handleSubmit: Function,
  onChange: Function,
  data: Object,
};

export function AuditLogsFilter(props: Props) {
  return (
    <View direction="row">
      <SchemaForm
        onSubmit={props.handleSubmit}
        onChange={props.onChange}
        formData={props.data}
        schema={{
          type: "object",
          properties: {
            dateFrom: {
              type: "string",
            },
            dateTo: {
              type: "string",
            },
            userId: {
              type: "string",
            },
            employeeId: {
              type: "string",
            },
          },
        }}
        uiSchema={{
          dateFrom: {
            "ui:widget": "date-picker",
            "ui:title": props.t("FROM"),
            "ui:options": {
              labelposition: "top",
            },
          },
          dateTo: {
            "ui:title": props.t("TO"),
            "ui:widget": "date-picker",
            "ui:options": {
              labelposition: "top",
            },
          },
          userId: {
            "ui:title": props.t("USER_ID"),
            "ui:options": { labelposition: "top" },
          },
          employeeId: {
            "ui:title": props.t("EMPLOYEE_ID"),
            "ui:options": { labelposition: "top" },
          },
        }}
        columns={4}
        externalSubmit
      />
    </View>
  );
}

export default compose(localize())(AuditLogsFilter);
